import { Box } from '@chakra-ui/react'
import { PackageItemTypeCategory } from 'BrokerTsLib/src/enums'
import { useOfferGrid } from '../../../context/OfferGridContext'
import { useGetGroupedRisks } from '../../../hooks/useEnumTravel'
import { SectionTitle } from './components/SectionTitle'
import { icons } from './icons'
import { OfferPackageColumnSection } from './OfferPackageColumnSection'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

export const OfferCestovkoHeaderColumn = () => {
  const { insuranceParams } = useInsuranceParamsContext()
  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { openedColumns, onSectionTitleClick } = useOfferGrid()
  const insuranceGroups = useGetGroupedRisks()

  return (
    <Box sx={{ display: 'grid', gap: 'px', alignSelf: 'end' }}>
      {insuranceGroups && Object.keys(insuranceGroups).map(key => {
        const items = insuranceGroups[key]
        const headerCells = items.map(x => { return { id: x.id.toString(), title: x.name } })
        const section = items[0]
        const icon: keyof typeof icons = section.groupId == PackageItemTypeCategory.Addons.toString() ? 'extras' : 'basic'

        return (
          <OfferPackageColumnSection
            key={section.groupId}
            id={section.groupId}
            title={section.groupName}
            icon={icon}
            isOpened={openedColumns.includes(section.groupId)}
            onClick={() => onSectionTitleClick(section.groupId)}
            headerCells={headerCells}
            isContracted={isContracted}
          />
        )
      })}

      <SectionTitle label="Sleva" />
    </Box>
  )
}
